import React, { FC, PropsWithChildren, useMemo } from "react";
import styled, { css } from "styled-components";
import { Button, Colors, FlexBox, Fonts, useBreakpoint } from "@brg/ui";
import { CustomInputProps } from "../inputs/components/dropdown/Dropdown";
import { useTranslation } from "react-i18next";
import { LayoutConst } from "../../../core";

//Чтоб обложка книги была равно размеру двух карточек + gap
export const BOOK_COVER_SIZE_1280 = 460;

const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/gif'];
const ALLOWED_FILE_TYPES_COMPETITION = ['image/jpeg']

export const ImagePreviewSectionWrapper = styled(FlexBox)<{
  width: number;
  height: number;
  widthMobile?: string;
  heightMobile?: string;
  withoutMac13Size?: boolean;
  isProjectEdit?: boolean;
  isBookEdit?: boolean;
  isCompetitionEdit?: boolean;
  isContextPage?: boolean;
  isTeamEmblem?: boolean;
  isProfileAvatar?: boolean;
}>`
  position: relative;
  width: ${(p) => p.width}px;
  height: ${(p) => p.height}px;
  cursor: ${(p) => p.isTeamEmblem || p?.isBookEdit ? 'normal' : 'pointer'};
  align-items: center;
  justify-content: center;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      
      ${({ isProfileAvatar, width, height, withoutMac13Size }) => isProfileAvatar ? css`
        width: ${width}px;
        height: ${height}px;
      ` : css`
      width: ${withoutMac13Size ? '270px' : `${LayoutConst.projectCover.m.w}px`};
      height: ${withoutMac13Size ? '270px' : (height === width) ? LayoutConst.projectCover.m.w : LayoutConst.projectCover.m.h}px;
      `};
    }


  @media (max-width: 940px) {
    width: ${(p) => (p.widthMobile ? p.widthMobile : "100vw")};
    height: ${(p) => (p.heightMobile ? p.heightMobile : "100vw")};
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  ${({ isProfileAvatar }) => isProfileAvatar && css`
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: calc(100vw - 20px);
      height: calc(100vw - 20px);
    }
`};

  ${({ isProjectEdit, withoutMac13Size, isCompetitionEdit, widthMobile, heightMobile }) => isProjectEdit || isCompetitionEdit ? css`
    @media(max-width: ${LayoutConst.screen.md}px) {
      width: ${LayoutConst.projectCover.m.w}px;
      height: ${LayoutConst.projectCover.m.h}px;
    }

    @media(max-width: 834px) {
      width: 100%;
      height: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: ${(p) => (widthMobile ? widthMobile : "100vw")};
      height: ${(p) => (heightMobile ? heightMobile : "100vw")};
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
  ` : null};

  ${({ isBookEdit, widthMobile, heightMobile }) => isBookEdit ? css`

    @media (max-width: 940px) {
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

  ` : null};

  ${({ isContextPage, width, height }) => isContextPage ? css`
    width: ${width}px;
    height: ${height}px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) { 
      width: ${width}px;
      height: ${height}px;
    }

    @media (max-width: 940px) {
      width: 100%;
      height: 100vh;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

` : null};

`;

export const ImagePreviewSectionHolder = styled(FlexBox)<
  {
    width: number;
    height: number;
    widthMobile?: string;
    heightMobile?: string;
    isCompetitionEdit?: boolean;
  } & CustomInputProps
>`
  position: absolute;
  font-family: 'Inter';
  font-size: 15px;
  line-height: 20px;
  color: ${Colors.galBlack47};
  background: ${(p) => p.theme.projectEdit.imgContainerBg};
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) { 
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: 940px) {
    align-items: center;
    
    justify-content: center;
    font-size: 13px;
  }
`;

export const BluredHolder = styled(ImagePreviewSectionHolder)`
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;
  color: #fff;
  background: transparent;
`;

export const ImagePreviewSectionPlacerButton = styled(Button.GreyMedium)`
  ${Fonts.Inter.smallText};
  //color: ${Colors.geoWhite100};
  padding: 0;
  align-items: center;
  text-align: center;
  width: 136px;
  height: 40px;
  justify-content: center;

  //border: 1px solid #8E9193;
  border: none !important;
  box-sizing: border-box;
  border-radius: 24px;
  

  @media (max-width: 960px) {
    align-items: center !important;
    justify-content: center;
  }
`;

export const ImagePreviewSectionImage = styled(FlexBox)<{
  url: string;
  width: number;
  height: number;
  holderVisible?: boolean
}>`
  position: absolute;
  width: 100%;
  height: 100%;

  background: url("${(p) => p.url}");
  background-size: cover;
  background-position: center center;

  ${ImagePreviewSectionHolder} {
    opacity: ${({ holderVisible }) => holderVisible ? 1 : 0 };
    transition: opacity 0.2s;
    background: linear-gradient(
      180deg,
      rgba(21, 21, 20, 0.9) 0%,
      rgba(21, 21, 20, 0.9) 100%
    );

    ${({ holderVisible }) => holderVisible && css`
      background: rgba(130, 130, 130, 0.60);
      backdrop-filter: blur(2.5px);
    `};
    @media(max-width: ${LayoutConst.screen.m}px) {
      background: none;
      opacity: 0;
    }
  }

  &:hover {
    ${ImagePreviewSectionHolder} {
      opacity: 1;
    }
  }

  @media (max-width: 940px) {
    // wtf??
    // border-radius: 100% !important;
  }
`;

const FileInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  display: block !important;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
`

const HolderContentWrapper = styled(FlexBox)<{isCollectionVote?: boolean}>`
  font-size: 15px;
  line-height: 20px;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
  
  ${({isCollectionVote}) => isCollectionVote && css`
    //@media(max-width: ${LayoutConst.screen.s}px) {
      width: 100%;
      height: 100%;
    //}
  `}
`;

export const HolderContent: FC<React.PropsWithChildren<any>> = ({ children, isCollectionVote, url, holderWidth, holderHeight, withoutText, placeholderMargin, placeholderMaxWidth, currentTheme }) => {
  return (
    <>
      <HolderContentWrapper
        offsetTop={placeholderMargin || placeholderMargin === 0 ? `${placeholderMargin}px` : 27}
        justify={"center"}
        isCollectionVote={isCollectionVote}
        style={{ textAlign: "center", maxWidth: isCollectionVote ? 'auto' : (placeholderMaxWidth || placeholderMaxWidth === 0) ? `${placeholderMaxWidth}px` : 210, whiteSpace: "break-spaces" }}
      >
        {children}
      </HolderContentWrapper>
    </>
  );
};

export interface ImagePreviewSectionProps {
  url?: string;
  placeholder?: string | undefined;
  onClick?: () => void;
  width: number;
  height: number;
  widthMobile?: string;
  heightMobile?: string;
  buttonHeight?: number;
  custom?: CustomInputProps;
  placeholderWidth?: number;
  placeholderMaxWidth?: number;
  placeholderHeight?: number;
  withoutText?: boolean;
  withoutMac13Size?: boolean;
  placeholderMargin?: number;
  currentTheme?:string;
  customRef?: any;
  isProjectEdit?: boolean;
  isCompetitionEdit?: boolean;
  isProfileAvatar?: boolean;
  isTeamEmblem?: boolean;
  canEditEmblem?: boolean;
  isContextPage?: boolean;
  isAdaptiveCard?: boolean;
  isCollectionVote?: boolean;
  v?: boolean;
  holderText?: string;
  coverLink?: { path: string; newTab: boolean }  | null;
}



export const ImagePreviewSection: FC<
  PropsWithChildren<ImagePreviewSectionProps>
> = ({
  children,
  url,
  custom,
  width,
  height,
  widthMobile,
  heightMobile,
  buttonHeight,
  //@ts-ignore
  fileInput,
  placeholder,
  placeholderWidth,
  placeholderMaxWidth,
  placeholderHeight,
  placeholderMargin,
  withoutText,
  withoutMac13Size,
  currentTheme,
  customRef,
  isProjectEdit,
  isCompetitionEdit,
  isTeamEmblem,
  holderText,
  isContextPage,
  isCollectionVote,
  canEditEmblem,
  isProfileAvatar,
  coverLink,
  isAdaptiveCard
}) => {
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const { t } = useTranslation();

  const userCanEditEmblem = useMemo(() => (canEditEmblem && isTeamEmblem), [isTeamEmblem, canEditEmblem]);

  const accept = isCompetitionEdit? ALLOWED_FILE_TYPES_COMPETITION.join(', ') : ALLOWED_FILE_TYPES.join(', ');

  return (
    <ImagePreviewSectionWrapper
      width={width}
      height={height}
      widthMobile={widthMobile}
      heightMobile={heightMobile}
      withoutMac13Size={withoutMac13Size}
      ref={customRef}
      isCompetitionEdit={isCompetitionEdit}
      isProjectEdit={isProjectEdit}
      isContextPage={isContextPage}
      isTeamEmblem={isTeamEmblem}
      isProfileAvatar={isProfileAvatar}
    >
      {url ? (
        <ImagePreviewSectionImage width={width} height={height} url={url} holderVisible={!!holderText?.length}>
            {isTeamEmblem ? (
              <>
                {coverLink ? (
                  <a style={{ width: '100%', height: '100%'}} href={coverLink.path} target={!!coverLink?.newTab ? '_blank' : '_self'} />
                ) : userCanEditEmblem ? (
                  <ImagePreviewSectionHolder
                    {...custom}
                    widthMobile={widthMobile}
                    heightMobile={heightMobile}
                    width={width}
                    height={height}
                  >
                    <FileInput
                      {...fileInput.inputProps}
                      accept={accept}
                    />
                    <ImagePreviewSectionPlacerButton
                      style={{ height: (buttonHeight ?? 40) + "px" }}
                    >
                      {t('change_image')}
                    </ImagePreviewSectionPlacerButton>
                    </ImagePreviewSectionHolder>   
                ) : !!holderText?.length ? (
                  <BluredHolder
                    {...custom}
                    widthMobile={widthMobile}
                    heightMobile={heightMobile}
                    width={width}
                    height={height}
                  > 
                    {holderText}
                  </BluredHolder>
                ) : null}
              </>
            ) : (
              <ImagePreviewSectionHolder
                {...custom}
                widthMobile={widthMobile}
                heightMobile={heightMobile}
                width={width}
                height={height}
              >
                <FileInput
                  {...fileInput.inputProps}
                  accept={accept}
                />
                <ImagePreviewSectionPlacerButton
                  style={{ height: (buttonHeight ?? 40) + "px" }}
                >
                  {is992 ? '' : t('change_image')}
                </ImagePreviewSectionPlacerButton>
              </ImagePreviewSectionHolder>
              
            )} 
        </ImagePreviewSectionImage>
      ) : placeholder ? (
        <ImagePreviewSectionHolder
          {...custom}
          widthMobile={widthMobile}
          heightMobile={heightMobile}
          width={width}
          height={height}
        >
          <FileInput
            {...fileInput.inputProps}
            accept={accept}
          />
          <HolderContent isCollectionVote={isCollectionVote} url={placeholder} holderWidth={placeholderWidth} holderHeight={placeholderHeight}  withoutText={withoutText} placeholderMargin={placeholderMargin} placeholderMaxWidth={placeholderMaxWidth} currentTheme={currentTheme}>{children}</HolderContent>
        </ImagePreviewSectionHolder>
      ) : ( 
        <ImagePreviewSectionHolder
            {...custom}
            widthMobile={widthMobile}
            heightMobile={heightMobile}
            isCompetitionEdit={isCompetitionEdit}
            width={width}
            height={height}
          >
            {!isAdaptiveCard && <FileInput
              {...fileInput.inputProps}
              accept={accept}
            />}
            <HolderContent isCollectionVote={isCollectionVote} holderWidth={placeholderWidth} holderHeight={placeholderHeight} placeholderMargin={placeholderMargin} placeholderMaxWidth={placeholderMaxWidth} currentTheme={currentTheme}>{children}</HolderContent>
          </ImagePreviewSectionHolder>
      )}
    </ImagePreviewSectionWrapper>
  );
}
import React, { FC, PropsWithChildren, useMemo } from "react";
import styled, { css } from "styled-components";
import { Button, Colors, FlexBox, Fonts, useBreakpoint } from "@brg/ui";
import { CustomInputProps } from "../inputs/components/dropdown/Dropdown";
import { useTranslation } from "react-i18next";
import { LayoutConst } from "../../../core";

//Чтоб обложка книги была равно размеру двух карточек + gap
export const BOOK_COVER_SIZE_1280 = 460;

const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/gif'];
const ALLOWED_FILE_TYPES_COMPETITION = ['image/jpeg']

export const ImagePreviewSectionWrapper = styled(FlexBox)<{
  width: number;
  height: number;
  widthMobile?: string;
  heightMobile?: string;
  withoutMac13Size?: boolean;
  isProjectEdit?: boolean;
  isBookEdit?: boolean;
  isCompetitionEdit?: boolean;
  isContextPage?: boolean;
  isTeamEmblem?: boolean;
  isProfileAvatar?: boolean;
}>`
  position: relative;
  width: ${(p) => p.width}px;
  height: ${(p) => p.height}px;
  cursor: ${(p) => p.isTeamEmblem || p?.isBookEdit ? 'normal' : 'pointer'};
  align-items: center;
  justify-content: center;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      
      ${({ isProfileAvatar, width, height, withoutMac13Size }) => isProfileAvatar ? css`
        width: ${width}px;
        height: ${height}px;
      ` : css`
      width: ${withoutMac13Size ? '270px' : `${LayoutConst.projectCover.m.w}px`};
      height: ${withoutMac13Size ? '270px' : (height === width) ? LayoutConst.projectCover.m.w : LayoutConst.projectCover.m.h}px;
      `};
    }


  @media (max-width: 940px) {
    width: ${(p) => (p.widthMobile ? p.widthMobile : "100vw")};
    height: ${(p) => (p.heightMobile ? p.heightMobile : "100vw")};
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  ${({ isProfileAvatar }) => isProfileAvatar && css`
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: calc(100vw - 20px);
      height: calc(100vw - 20px);
    }
`};

  ${({ isProjectEdit, withoutMac13Size, isCompetitionEdit, widthMobile, heightMobile }) => isProjectEdit || isCompetitionEdit ? css`
    @media(max-width: ${LayoutConst.screen.md}px) {
      width: ${LayoutConst.projectCover.m.w}px;
      height: ${LayoutConst.projectCover.m.h}px;
    }

    @media(max-width: 834px) {
      width: 100%;
      height: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: ${(p) => (widthMobile ? widthMobile : "100vw")};
      height: ${(p) => (heightMobile ? heightMobile : "100vw")};
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
  ` : null};

  ${({ isBookEdit, widthMobile, heightMobile }) => isBookEdit ? css`

    @media (max-width: 940px) {
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

  ` : null};

  ${({ isContextPage, width, height }) => isContextPage ? css`
    width: ${width}px;
    height: ${height}px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) { 
      width: ${width}px;
      height: ${height}px;
    }

    @media (max-width: 940px) {
      width: 100%;
      height: 100vh;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

` : null};

`;

export const ImagePreviewSectionHolder = styled(FlexBox)<
  {
    width: number;
    height: number;
    widthMobile?: string;
    heightMobile?: string;
    isCompetitionEdit?: boolean;
  } & CustomInputProps
>`
  position: absolute;
  font-family: 'Inter';
  font-size: 15px;
  line-height: 20px;
  color: ${Colors.galBlack47};
  background: ${(p) => p.theme.projectEdit.imgContainerBg};
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) { 
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: 940px) {
    align-items: center;
    
    justify-content: center;
    font-size: 13px;
  }
`;

export const BluredHolder = styled(ImagePreviewSectionHolder)`
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;
  color: #fff;
  background: transparent;
`;

export const ImagePreviewSectionPlacerButton = styled(Button.GreyMedium)`
  ${Fonts.Inter.smallText};
  //color: ${Colors.geoWhite100};
  padding: 0;
  align-items: center;
  text-align: center;
  width: 136px;
  height: 40px;
  justify-content: center;

  //border: 1px solid #8E9193;
  border: none !important;
  box-sizing: border-box;
  border-radius: 24px;
  

  @media (max-width: 960px) {
    align-items: center !important;
    justify-content: center;
  }
`;

export const ImagePreviewSectionImage = styled(FlexBox)<{
  url: string;
  width: number;
  height: number;
  holderVisible?: boolean
}>`
  position: absolute;
  width: 100%;
  height: 100%;

  background: url("${(p) => p.url}");
  background-size: cover;
  background-position: center center;

  ${ImagePreviewSectionHolder} {
    opacity: ${({ holderVisible }) => holderVisible ? 1 : 0 };
    transition: opacity 0.2s;
    background: linear-gradient(
      180deg,
      rgba(21, 21, 20, 0.9) 0%,
      rgba(21, 21, 20, 0.9) 100%
    );

    ${({ holderVisible }) => holderVisible && css`
      background: rgba(130, 130, 130, 0.60);
      backdrop-filter: blur(2.5px);
    `};
    @media(max-width: ${LayoutConst.screen.m}px) {
      background: none;
      opacity: 0;
    }
  }

  &:hover {
    ${ImagePreviewSectionHolder} {
      opacity: 1;
    }
  }

  @media (max-width: 940px) {
    // wtf??
    // border-radius: 100% !important;
  }
`;

const FileInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  display: block !important;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
`

const HolderContentWrapper = styled(FlexBox)<{isCollectionVote?: boolean}>`
  font-size: 15px;
  line-height: 20px;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
  
  ${({isCollectionVote}) => isCollectionVote && css`
    //@media(max-width: ${LayoutConst.screen.s}px) {
      width: 100%;
      height: 100%;
    //}
  `}
`;

export const HolderContent: FC<React.PropsWithChildren<any>> = ({ children, isCollectionVote, url, holderWidth, holderHeight, withoutText, placeholderMargin, placeholderMaxWidth, currentTheme }) => {
  return (
    <>
      <HolderContentWrapper
        offsetTop={placeholderMargin || placeholderMargin === 0 ? `${placeholderMargin}px` : 27}
        justify={"center"}
        isCollectionVote={isCollectionVote}
        style={{ textAlign: "center", maxWidth: isCollectionVote ? 'auto' : (placeholderMaxWidth || placeholderMaxWidth === 0) ? `${placeholderMaxWidth}px` : 210, whiteSpace: "break-spaces" }}
      >
        {children}
      </HolderContentWrapper>
    </>
  );
};

export interface ImagePreviewSectionProps {
  url?: string;
  placeholder?: string | undefined;
  onClick?: () => void;
  width: number;
  height: number;
  widthMobile?: string;
  heightMobile?: string;
  buttonHeight?: number;
  custom?: CustomInputProps;
  placeholderWidth?: number;
  placeholderMaxWidth?: number;
  placeholderHeight?: number;
  withoutText?: boolean;
  withoutMac13Size?: boolean;
  placeholderMargin?: number;
  currentTheme?:string;
  customRef?: any;
  isProjectEdit?: boolean;
  isCompetitionEdit?: boolean;
  isProfileAvatar?: boolean;
  isTeamEmblem?: boolean;
  canEditEmblem?: boolean;
  isContextPage?: boolean;
  isAdaptiveCard?: boolean;
  isCollectionVote?: boolean;
  v?: boolean;
  holderText?: string;
  coverLink?: { path: string; newTab: boolean }  | null;
}



export const ImagePreviewSection: FC<
  PropsWithChildren<ImagePreviewSectionProps>
> = ({
  children,
  url,
  custom,
  width,
  height,
  widthMobile,
  heightMobile,
  buttonHeight,
  //@ts-ignore
  fileInput,
  placeholder,
  placeholderWidth,
  placeholderMaxWidth,
  placeholderHeight,
  placeholderMargin,
  withoutText,
  withoutMac13Size,
  currentTheme,
  customRef,
  isProjectEdit,
  isCompetitionEdit,
  isTeamEmblem,
  holderText,
  isContextPage,
  isCollectionVote,
  canEditEmblem,
  isProfileAvatar,
  coverLink,
  isAdaptiveCard
}) => {
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const { t } = useTranslation();

  const userCanEditEmblem = useMemo(() => (canEditEmblem && isTeamEmblem), [isTeamEmblem, canEditEmblem]);

  const accept = isCompetitionEdit? ALLOWED_FILE_TYPES_COMPETITION.join(', ') : ALLOWED_FILE_TYPES.join(', ');

  return (
    <ImagePreviewSectionWrapper
      width={width}
      height={height}
      widthMobile={widthMobile}
      heightMobile={heightMobile}
      withoutMac13Size={withoutMac13Size}
      ref={customRef}
      isCompetitionEdit={isCompetitionEdit}
      isProjectEdit={isProjectEdit}
      isContextPage={isContextPage}
      isTeamEmblem={isTeamEmblem}
      isProfileAvatar={isProfileAvatar}
    >
      {url ? (
        <ImagePreviewSectionImage width={width} height={height} url={url} holderVisible={!!holderText?.length}>
            {isTeamEmblem ? (
              <>
                {coverLink ? (
                  <a style={{ width: '100%', height: '100%'}} href={coverLink.path} target={!!coverLink?.newTab ? '_blank' : '_self'} />
                ) : userCanEditEmblem ? (
                  <ImagePreviewSectionHolder
                    {...custom}
                    widthMobile={widthMobile}
                    heightMobile={heightMobile}
                    width={width}
                    height={height}
                  >
                    <FileInput
                      {...fileInput.inputProps}
                      accept={accept}
                    />
                    <ImagePreviewSectionPlacerButton
                      style={{ height: (buttonHeight ?? 40) + "px" }}
                    >
                      {t('change_image')}
                    </ImagePreviewSectionPlacerButton>
                    </ImagePreviewSectionHolder>   
                ) : !!holderText?.length ? (
                  <BluredHolder
                    {...custom}
                    widthMobile={widthMobile}
                    heightMobile={heightMobile}
                    width={width}
                    height={height}
                  > 
                    {holderText}
                  </BluredHolder>
                ) : null}
              </>
            ) : (
              <ImagePreviewSectionHolder
                {...custom}
                widthMobile={widthMobile}
                heightMobile={heightMobile}
                width={width}
                height={height}
              >
                <FileInput
                  {...fileInput.inputProps}
                  accept={accept}
                />
                <ImagePreviewSectionPlacerButton
                  style={{ height: (buttonHeight ?? 40) + "px" }}
                >
                  {is992 ? '' : t('change_image')}
                </ImagePreviewSectionPlacerButton>
              </ImagePreviewSectionHolder>
              
            )} 
        </ImagePreviewSectionImage>
      ) : placeholder ? (
        <ImagePreviewSectionHolder
          {...custom}
          widthMobile={widthMobile}
          heightMobile={heightMobile}
          width={width}
          height={height}
        >
          <FileInput
            {...fileInput.inputProps}
            accept={accept}
          />
          <HolderContent isCollectionVote={isCollectionVote} url={placeholder} holderWidth={placeholderWidth} holderHeight={placeholderHeight}  withoutText={withoutText} placeholderMargin={placeholderMargin} placeholderMaxWidth={placeholderMaxWidth} currentTheme={currentTheme}>{children}</HolderContent>
        </ImagePreviewSectionHolder>
      ) : ( 
        <ImagePreviewSectionHolder
            {...custom}
            widthMobile={widthMobile}
            heightMobile={heightMobile}
            isCompetitionEdit={isCompetitionEdit}
            width={width}
            height={height}
          >
            {!isAdaptiveCard && <FileInput
              {...fileInput.inputProps}
              accept={accept}
            />}
            <HolderContent isCollectionVote={isCollectionVote} holderWidth={placeholderWidth} holderHeight={placeholderHeight} placeholderMargin={placeholderMargin} placeholderMaxWidth={placeholderMaxWidth} currentTheme={currentTheme}>{children}</HolderContent>
          </ImagePreviewSectionHolder>
      )}
    </ImagePreviewSectionWrapper>
  );
}
